<script>
    export let data = {}

    function submit(){
        return
    }

    function set_estado(){
        console.log(data.debeaprobar)
        if(!data.id){
            data.estado = data.debeaprobar===''?'TRAMITE':'PE_APROB'
        }
    }

</script>
    <form on:submit|preventDefault={submit} >
        <div class="mb-2 row">
            <div class="col-12 text-end">{data.usuario}</div>
        </div>
        <div class="mb-2 row">
            <label for="" class="col-sm-2 col-form-label">Cliente</label>
            <div class="col-sm-3">
              <input type="text" class="form-control" bind:value={data.idcliente} readonly>
            </div>
            <div class="col">
                <input type="text" class="form-control-plaintext" tabindex="-1" bind:value={data.nombre}>
            </div>
            <div class="col">
                <input type="text" class="form-control" tabindex="-1" bind:value={data.nrointercambio} readonly title="Nro Intercambio">
            </div>
        </div>
        
        <div class="row mb-2">
            <label for="" class="col-sm-2 col-form-label">Tipo/Producto</label>
            <div class="col-3">
                <select class="form-select" bind:value={data.tipo} aria-label="Tipos">
                    <option selected>Tipo</option>
                    <option value="VEN">VEN</option>
                    <option value="ALQ">ALQ</option>
                    <option value="TRVL">TRVL</option>
                    <option value="OTR">OTR</option>
                </select>
            </div>
            <div class="col-7"><input class="form-control text-uppercase" bind:value={data.producto}></div>
        </div>

        <div class="row mb-2">
            <label for="" class="col-sm-2 col-form-label">Ejecutivo</label>
            <div class="col-2"><input class="form-control" bind:value={data.usuario} readonly></div>
            <div class="col-2">&nbsp;</div>
            <label for="" class="col-sm-2 col-form-label">Autoriza</label>
            <div class="col-2">
                <select class="form-select" aria-label="Ejecutivos" bind:value={data.debeaprobar} on:change={set_estado}>
                    <option value="" selected>No requiere</option>
                    <option value="PGERMANI">PGERMANI</option>
                    <option value="HJOSE">HJOSE</option>
                    <option value="DMENDOZA">DMENDOZA</option>
                </select>
            </div>
        </div>

        <div class="row mb-2">
            <label for="" class="col-sm-2 col-form-label">Fecha</label>
            <div class="col-2"><input class="form-control" bind:value={data.fecha} readonly></div>
            <div class="col-2">&nbsp;</div>
            <label for="" class="col-sm-2 col-form-label">Fecha Liq</label>
            <div class="col-2"><input class="form-control" bind:value={data.fechaliq} readonly></div>
        </div>

        <div class="row mb-2">
            <label for="" class="col-sm-2 col-form-label">Estado</label>
            <div class="col-2"><input class="form-control" bind:value={data.estado} readonly/></div>
            <div class="col"></div>
        </div>


        <div class="row mb-2">
            <label for="" class="col-sm-2 col-form-label">Observacion</label>
            <div class="col-10"><textarea class="form-control" rows=6 bind:value={data.observ}></textarea></div>
        </div>

    </form>